import React from 'react'
import ResultItem from '../../../pack/form/result/ResultItem'
import { useState } from 'react'
import { useEffect } from 'react'

const WorkLinePlaceResultFactory = ({ result }) => {

    const [department, setDepartment] = useState(null)

    useEffect(() => {
        if (result && result.department) {
            setDepartment(result.department)
        } else {
            setDepartment(null)
        }
    }, [result])

  return (
    <>
        {
            department && department.type && department.type === 'factory' ?
                <>
                    {/* <ResultItem
                        text='Назва (повна)'
                        value={department.factory ? department.factory.name : ''}
                    /> */}
                    <ResultItem
                        text='Назва (коротка)'
                        value={department.factory ? department.factory.slug : ''}
                    />
                    <ResultItem
                        text='Назва лінії виробництва'
                        value={department.factoryLine ? department.factoryLine.name : ''}
                    />
                </>
            : ''
        }
    </>
  )
}

export default WorkLinePlaceResultFactory